import { CurrencyPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, ViewEncapsulation } from '@angular/core';
import { LocalizationConfigService } from '@scalefast/config-angular';
import { AppOptionsPriceBaseComponent } from 'src/app/components/product/product-price/product-price-base.componen';

@Component({
  selector: 'app-meta-option-crossed-price',
  standalone: true,
  template: `@if (showCrossedPrice) {
    <s class="options-price__crossed">
      {{ crossedPriceManager.finalCrossedPrice | currency: currency : 'symbol' : '1.2-2' }}
    </s>
  }`,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CurrencyPipe],
})
export class AppOptionsMetaCrossPriceComponent extends AppOptionsPriceBaseComponent {
  private localizationConfigService = inject(LocalizationConfigService);

  readonly currency;

  constructor() {
    super();
    this.currency = this.localizationConfigService.get().currency;
  }
}
